import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, CircularProgress, Container, Link as MuiLink, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { ThemeRecord, fetchThemesForDomain } from '../utils/formsApi';

const ThemesListPage: React.FC = () => {
  const [themes, setThemes] = useState<ThemeRecord[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchThemesForDomain()
      .then((availableThemes) => {
        if (isMounted) setThemes(availableThemes);
      })
      .catch((requestError) => {
        console.error('Failed to fetch themes:', requestError);
        if (isMounted) setError('Failed to load the available themes.');
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4, textAlign: 'left' }}>
      <Typography component={Link} to="/" color="primary" sx={{ textDecoration: 'none' }}>
        ← Form Renderer
      </Typography>
      <Typography variant="h4" sx={{ mt: 2, mb: 3 }}>Available Themes</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {isLoading ? <CircularProgress aria-label="Loading themes" /> : (
        <Paper>
          <TableContainer>
            <Table aria-label="Available themes">
              <TableHead>
                <TableRow>
                  <TableCell>UUID</TableCell>
                  <TableCell>Theme Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {themes.map((theme) => (
                  <TableRow key={theme.uuid} hover>
                    <TableCell sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>
                      <MuiLink component={Link} to={`/themes/${encodeURIComponent(theme.uuid)}`}>{theme.uuid}</MuiLink>
                    </TableCell>
                    <TableCell>{theme.themeName}</TableCell>
                  </TableRow>
                ))}
                {themes.length === 0 && (
                  <TableRow><TableCell colSpan={2} align="center">No themes are available for this domain.</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Container>
  );
};

export default ThemesListPage;
